// extracted by mini-css-extract-plugin
module.exports = {"rootContainer":"UnauthorizedError_rootContainer__3XhQs"};